import type { UseOverlayReturnOptions } from '@fs/zion-ui'
import { Paragraph, DialogOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DIALOG_SIZE from '../../../common/dialogSize'

type Props = { overlay: UseOverlayReturnOptions }
export default function PossibleDuplicatesNotAvailableDialog({ overlay }: Props): JSX.Element {
  const [t] = useTranslation()
  return (
    <DialogOverlay
      {...overlay}
      title={t('tree-person.possible-duplicates.label')}
      size={DIALOG_SIZE}
      data-testid="possible-duplicates-not-available"
    >
      <Paragraph size="sm">{t('tree-person.possible-duplicates-not-available.description')}</Paragraph>
    </DialogOverlay>
  )
}
